import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as harpraApi from './../services/api.service'
import {
  SET_SUBSCRIPTION_INFO,
  SET_USER_DATA,
  CLEAR_SUBSCRIPTION_INFO,
  CLEAR_USER_DATA
} from './mutation-types'
import { ClientAuthError } from 'msal'

Vue.use(Vuex)

Vue.config.devtools = true

export default new Vuex.Store({
  state: {
    user: null,
    subscriptionInfo: null
  },
  mutations: {
    [SET_USER_DATA](state, userData) {
      state.user = userData
      //TODO: localstorage? or that vuex addon?

      axios.defaults.headers.common['Authorization'] = `Bearer ${userData.token}`
    },
    [SET_SUBSCRIPTION_INFO](state, subscriptionInfo) {
      state.subscriptionInfo = subscriptionInfo
    },
    [CLEAR_USER_DATA](state) {
      state.user = null
      axios.defaults.headers.common['Authorization'] = null
    },
    [CLEAR_SUBSCRIPTION_INFO](state) {
      state.subscriptionInfo = null
    }
  },
  actions: {
    async login({ commit }) {
      try {
        let loginResponse = await this.$auth.loginAsync()

        commit(SET_USER_DATA, loginResponse.userData)

        if (loginResponse.newUser) {
          await harpraApi.registerNewUserAsync()
        }
      } catch (error) {
        if (error instanceof ClientAuthError) {
          throw error
        }

        if (error.response.status !== 409) {
          throw error
        }
      }
    },
    async logout({ commit }) {
      commit(CLEAR_USER_DATA)
      commit(CLEAR_SUBSCRIPTION_INFO)

      this.$auth.logout()
    },
    async fetchSubscription({ commit }) {
      let subscriptionInfo = await harpraApi.getSubscriptionInfoAsync()

      commit(SET_SUBSCRIPTION_INFO, subscriptionInfo)
    }
  },
  getters: {
    isLoggedIn: state => {
      return !!state.user
    },
    userName: state => {
      return state.user?.name
    },
    isActive: state => {
      return !!state.subscriptionInfo?.isActive
    },
    isCompanionActive: state => {
      return !!state.subscriptionInfo?.isCompanionActive
    },
    isWebARActive: state => {
      return !!state.subscriptionInfo?.isWebARActive
    },
    isBusiness: state => {
      return state.subscriptionInfo?.tier === 2
    },
    isEnterprise: state => {
      return state.subscriptionInfo?.tier === 4
    },
    subscriptionInfo: state => {
      return state.subscriptionInfo;
    },
  }
})
